import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("cl_token")) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("cl_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const accept = (data) => {
    localStorage.setItem("cl_token", data.token);
    setUser(data.user);
  };
  const login = async (email, password) => accept((await api.post("/auth/login", { email, password })).data);
  const register = async (body) => accept((await api.post("/auth/register", body)).data);
  const demo = async () => accept((await api.post("/auth/demo")).data);
  const logout = () => {
    localStorage.removeItem("cl_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, demo, logout, refresh }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
